export const navActive = (path = '', searchString) => path.indexOf(searchString) !== -1;

export default {
    navActive
};